/* eslint-disable max-len */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import GridCard from "../../components/GridCard/GridCard";
import t from "../../../Common/utils/translation/translator";
import singleDoubleAxis from "../../../Cartesian/Assets/single_double_axes.gif";
import cantiliver from "../../../Cartesian/Assets/cantiliver.png";
import "./Kinematics.scss";
import { KINEMATICS_OPTIONS } from "../../store/data/cartesianData";
import {
  selectCartesianSteps,
  selectKinematics,
  setCartesianCurrentStep,
  setKinematics
} from "../../store/slices/cartesian";
import { updateConfiguration } from "../../../Common/store/slices/common";

const Kinematics = ({ ...props }) => {
  const dispatch = useDispatch();
  const steps = useSelector(selectCartesianSteps);
  const kinematics = useSelector(selectKinematics);

  const handleSetKinematics = (c) => {
    dispatch(
      setKinematics({
        type: c,
        isValid: true
      })
    );
    dispatch(setCartesianCurrentStep(steps.MECHANICS));
    dispatch(updateConfiguration());
  };
  return (
    <div className="text-gray-700" {...props}>
      <span className="mt-1 mb-3 font-semibold">{t("cartesian.ui.kinematics_title")}</span>

      <GridCard
        image={singleDoubleAxis}
        title={t("cartesian.ui.kinematics-linear_axes_title")}
        description={t("cartesian.ui.kinematics-linear_axes_text")}
        direction={t("cartesian.ui.kinematics-direction-horizontal")}
        onClick={() => {
          handleSetKinematics(KINEMATICS_OPTIONS.linear);
        }}
        selected={kinematics.type === KINEMATICS_OPTIONS.linear}
      />
      <GridCard
        image={cantiliver}
        title={t("cartesian.ui.kinematics-cantilever_axes_title")}
        description={t("cartesian.ui.kinematics-cantilever_axes_text")}
        direction={t("cartesian.ui.kinematics-direction-vertical")}
        onClick={() => {
          handleSetKinematics(KINEMATICS_OPTIONS.cantilever);
        }}
        selected={kinematics.type === KINEMATICS_OPTIONS.cantilever}
        disabled
      />
    </div>
  );
};

export default Kinematics;
